const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeycloak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.117,
    height: 150.658,
    viewBox: "0 0 44.216 39.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m88.61 138.456 5.716-9.865 23.018-.004 5.686 9.965.007 19.932-5.691 9.957-23.012.008-5.782-9.965z",
    style: {
      display: "inline",
      fill: "#4d4d4d",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.552 158.481h10.375l-5.699-10.041 4.634-9.982-9.252-.002-5.795 10.065",
    style: {
      fill: "#ededed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.073 158.481h7.582l6.706-9.773-6.589-10.156h-8.921l-5.373 9.814z",
    style: {
      fill: "#e0e0e0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.815 148.52 5.738 9.964h10.374l-5.636-9.93z",
    style: {
      fill: "#acacac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.589 148.522 6.484 9.963h7.582l6.601-9.959z",
    style: {
      fill: "#9e9e9e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.157 148.529-1.958.569-1.877-.572 7.667-13.288 1.918 3.316",
    style: {
      fill: "#00b8e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.9 158.482-1.909 3.332-5.093-5.487-2.58-7.797v-.004h3.838",
    style: {
      fill: "#33c6e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.322 148.526h-.003v.003l-1.918 3.322-1.925-3.307 1.952-3.386 5.728-9.92h3.834",
    style: {
      fill: "#008aaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 158.481h11.611l-.007-19.93h-11.605z",
    style: {
      fill: "#d4d4d4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 148.554v9.93h11.59v-9.93z",
    style: {
      fill: "#919191",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.992 161.817h-3.836l-5.755-9.966 1.918-3.321z",
    style: {
      fill: "#00b8e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.333 148.526-7.669 13.289c-.705-1.036-1.913-3.331-1.913-3.331l5.753-9.959z",
    style: {
      fill: "#008aaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.495 161.815-3.831-.001 7.67-13.288 1.917-3.317 1.921 3.34m-3.839-.023h-3.828l-5.755-9.973 1.905-3.314 4.658 5.922z",
    style: {
      fill: "#00b8e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.25 145.205v.003l-1.917 3.318-7.677-13.286 3.841.002z",
    style: {
      fill: "#33c6e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.330729
    },
    transform: "translate(-82.815 -128.588)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycloak);
export default __webpack_public_path__ + "static/media/keycloak.af7740635f521ebffccef6bc708a04a1.svg";
export { ForwardRef as ReactComponent };